/*
* @author 友人a丶
* @date 2022-07-11
*
* 系统UI设置状态
* */

import {defineStore} from "pinia";

const setting = defineStore('setting', {
    state() {
        /*
        * 同步本地侧边栏的状态
        * */
        const collapsed = localStorage.getItem("collapsed");
        /*初始数据列表*/
        return {
            collapsed: (!(collapsed === 'false' || !collapsed)),//收缩菜单栏
            collapsedWidth: 70, //侧边栏的收缩后的宽度
            expandWidth: 200, //侧边栏展开的宽度
            hideMenu: false //隐藏侧边栏
        }
    },
    actions: {
        /*
        * 切换收缩、展开
        * */
        toggleCollapsed(flag) {
            localStorage.setItem("collapsed", flag);
            this.collapsed = flag;
        }
    }
})

export default setting;